import { YesObject } from '@yes.technology/react-toolkit'
import React from 'react'

import {
  Literal,
  Optional,
  Record,
  String,
  Union,
  Array,
  Unknown
} from 'runtypes'

import { PublicButtonPropsWithType } from 'shared/utils'
import { StyleMap } from 'site/Renderer/hooks/useStyleMap'

export type PositionType = 'left' | 'right'

export type ArticleButton =
  | {
      label: string
      href: string
      target?: string
      style?: React.CSSProperties
    }
  | PublicButtonPropsWithType

export type ArticleContainerProps = {
  props: {
    position: PositionType
    complement: string
    des?: string
    imageUrl?: string | YesObject[]
    imageAlt?: string
    buttons?: ArticleButton[]
    textColor?: string
    styleMap?: StyleMap
  }
}

const Position = Union(Literal('left'), Literal('right'))

const LinkButtonRecord = Record({
  label: String,
  href: String,
  target: Optional(String)
})

const PublicButtonRecord = Record({
  type: Literal('public'),
  label: Optional(String),
  href: Optional(String),
  link: Optional(Record({ url: String, target: Optional(String) }))
})

const ButtonRecord = Union(PublicButtonRecord, LinkButtonRecord)

export const ArticleContainerTypeGuard = Record({
  position: Position,
  complement: String,
  des: Optional(String),
  imageUrl: Optional(String || Array(Unknown)),
  imageAlt: Optional(String),
  buttons: Optional(Array(ButtonRecord)),
  styleMap: Optional(Unknown)
})
